


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Connector from '@vue-polkadot/vue-api';
import ItemCard from '@/components/shared/wrapper/ItemCard.vue'
import Money from '@/components/shared/format/Money.vue'
import WithLabel from '@/components/shared/format/WithLabel.vue'
import { AccountId } from '@polkadot/types/interfaces';
import { DeriveStakingQuery } from '@polkadot/api-derive/types';
import { PayoutValidator } from './types';

import BN from 'bn.js'

const components = {
  ItemCard,
  Money,
  WithLabel
}

@Component({ components })
export default class ValidatorRow extends Vue {
  @Prop() public validator!: PayoutValidator;
  private nominatorsVisible = false;
  private loading: boolean = false;

  get validatorId(): string {
    return this.validator?.validatorId;
  }

  get available(): BN {
    return this.validator?.available
  }
}
